var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoom1 = function SvgZoom1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2264_200020)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0073EA",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.592 18.644c.08.138.107.295.115.472l.012.236v1.65l.011.236c.024.386.308.67.697.695l.235.012v-2.593l.011-.236c.01-.175.036-.335.117-.474a.943.943 0 0 1 1.632.003c.08.138.105.298.115.471l.011.236v1.65l.012.236a.72.72 0 0 0 .696.695l.235.012v-2.829a1.886 1.886 0 0 0-3.3-1.247 1.884 1.884 0 0 0-2.47-.315c-.184-.205-.595-.324-.831-.324v4.715l.236-.012c.394-.026.68-.303.695-.695l.012-.236v-1.65l.012-.236c.01-.178.035-.334.115-.473a.945.945 0 0 1 1.632 0m-16.14 3.29.236.01h3.536l-.012-.234c-.032-.388-.306-.671-.695-.696l-.236-.012h-2.122l2.829-2.83-.012-.234a.713.713 0 0 0-.695-.697l-.236-.01-3.536-.001.012.236c.03.384.309.673.695.695l.236.012h2.121l-2.828 2.83.011.235a.72.72 0 0 0 .696.695m12.512-4.014a2.358 2.358 0 1 1-3.334 3.334 2.358 2.358 0 0 1 3.334-3.334m-.667.668a1.416 1.416 0 1 1-2.003 2 1.416 1.416 0 0 1 2.003-2m-5.95-1.358a2.357 2.357 0 1 1-1.669 4.024 2.358 2.358 0 0 1 1.666-4.024zm1 1.357a1.415 1.415 0 1 1-2.003 2 1.415 1.415 0 0 1 2.002-2",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2264_200020",
    width: 38.83,
    height: 42.685,
    x: 0.219,
    y: 0.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2264_200020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2264_200020",
    result: "shape"
  })))));
};
export default SvgZoom1;